import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { EventsModel } from '@app/events/events.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { DataArrayService } from '../events.service';
import { FormControl, Validators } from '@angular/forms';
import { DataStorageService } from '@app/shared/services/data-storage.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ApiService, AuthenticationService } from '@app/shared/services';
import esJson from '../../../assets/i18n/es.json';
import enJson from '../../../assets/i18n/en.json';

@Component({
  selector: 'app-events-form',
  templateUrl: './events-form.component.html',
  styleUrls: ['./events-form.component.scss'],
  standalone: false
})
export class EventsFormComponent implements OnInit {
  langJson = (localStorage.getItem('lang') === 'es') ? esJson : enJson;

  @Output() newItem = new EventEmitter<EventsModel>();

  showAlert = false;
  alertMessage = '';
  alertType: 'success' | 'error' | 'info' | 'warn' = 'info';

  private showBottomAlert(
    message: string,
    type: 'success' | 'error' | 'info' | 'warn' = 'info',
    duration: number = 3000
  ) {
    this.alertMessage = message;
    this.alertType = type;
    this.showAlert = true;

    if (duration > 0) {
      setTimeout(() => {
        this.showAlert = false;
      }, duration);
    }
  }

  nuevoItem: EventsModel = {
    id: '',
    name: '',
    price: null,
    amount: null,
    minTickets: null,
    maxTickets: null,
    maxPerUser: null,
    description: '',
    location: '',
    iniDate: '',
    endDate: '',
    iniSale: '',
    endSale: '',
    categories: []
  };

  imagePath: any;
  imgURL: any;
  public message: string;
  files: any;
  messageError: string;
  loadingFile: boolean;
  sizeOfOriginalImage: number;
  imgResultAfterCompress: string;
  localCompressedURl: any;
  sizeOFCompressedImage: number;
  imageFileCompress: any;

  // Formulario dinámico
  isNominative: boolean = false;
  formData: any[] = [];
  editingFieldIndex: number = -1;
  fieldTypes: string[] = ['text', 'email', 'number', 'tel', 'date', 'textarea', 'select'];

  eventUserCategories: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<EventsFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data_form: any,
    private dataArrayService: DataArrayService,
    public dataStorageService: DataStorageService,
    private imageCompress: NgxImageCompressService,
    private apiService: ApiService,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit(): void {
    this.dataStorageService.fetchEventUserCategories().subscribe(response => {
      this.eventUserCategories = response.categories;
    });
  }

  compressFile(image: string, fileName: string) {
    const orientation = -1;
    this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
    this.imageCompress.compressFile(image, orientation, 50, 50).then(
      result => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
        const imageName = fileName;
        const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
        this.imageFileCompress = new File([result], imageName, { type: 'image/jpeg' });
      });
  }

  dataURItoBlob(dataURI: string) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([int8Array], { type: 'image/jpeg' });
  }

  preview(event: any) {
    this.loadingFile = true;
    let fileName: any;
    this.files = event.target.files[0];
    fileName = this.files['name'];
    const reader = new FileReader();
    reader.readAsDataURL(this.files);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      this.compressFile(this.imgURL, fileName);
    };
    this.loadingFile = false;
  }

  onSubmit(form: NgForm) {
    this.authenticationService.setLoader(true);
    if (!form.valid) {
      return;
    }

    const name = form.value.name?.trim() || '';
    const price = form.value.price || '';
    const amount = form.value.amount ? Number(form.value.amount) : null;
    const minTickets = form.value.minTickets ? Number(form.value.minTickets) : null;
    const maxTickets = form.value.maxTickets ? Number(form.value.maxTickets) : null;
    const maxPerUser = form.value.maxPerUser ? Number(form.value.maxPerUser) : null;
    const description = form.value.description?.trim() || '';
    const location = form.value.location?.trim() || '';
    const iniDate = form.value.iniDate || '';
    const endDate = form.value.endDate || '';
    const iniSale = form.value.iniSale || '';
    const endSale = form.value.endSale || '';
    const categories = form.value.categories || null;

    const nuevoDato: EventsModel = {
      id: '',
      name: name,
      price: price,
      amount: amount,
      minTickets: minTickets,
      maxTickets: maxTickets,
      maxPerUser: maxPerUser,
      description: description,
      location: location,
      iniDate: iniDate,
      endDate: endDate,
      iniSale: iniSale,
      endSale: endSale,
      isNominative: this.isNominative,
      formData: this.isNominative ? this.formData : undefined,
      categories: categories
    };

    let nuevoDatoFiltrado: any = {};
    for (let key in nuevoDato) {
      if (
        (nuevoDato as any)[key] !== '' &&
        (nuevoDato as any)[key] !== undefined &&
        (nuevoDato as any)[key] !== null
      ) {
        nuevoDatoFiltrado[key] = (nuevoDato as any)[key];
      }
    }
    // Asegurar que formData siempre se incluya, incluso si está vacío
    if (nuevoDato.formData !== undefined) {
      nuevoDatoFiltrado.formData = JSON.stringify(nuevoDato.formData);
    }

    if (nuevoDato.categories !== undefined) {
      if (nuevoDato.categories.length > 0) {
        nuevoDatoFiltrado.categories = JSON.stringify(nuevoDato.categories);
      } else {
        delete nuevoDatoFiltrado.categories;
      }
    }

    const updateData2 = new FormData();
    for (const key in nuevoDatoFiltrado) { // Agrega todos los campos al updateData (incluido el archivo)
      if (nuevoDatoFiltrado.hasOwnProperty(key)) {
        updateData2.append(key, nuevoDatoFiltrado[key]);
      }
    }

    if (this.files) {
      updateData2.append('image', this.files, this.imageFileCompress.name);
    }

    this.dataStorageService
      .createTicketTypeWithAccount(updateData2)
      .subscribe(response => {
        this.dataArrayService.addData(response.data);
        this.dialogRef.close(response.data);
      });
  }

  onClose() {
    this.dialogRef.close();
  }

  // Validators
  name_control = new FormControl('', [Validators.required]);

  getErrorMessage_name() {
    if (this.name_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  price_control = new FormControl('', [Validators.required]);

  getErrorMessage_price() {
    if (this.price_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  amount_control = new FormControl('', [Validators.required]);

  getErrorMessage_amount() {
    if (this.amount_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  minTickets_control = new FormControl('', [Validators.required]);

  getErrorMessage_minTickets() {
    if (this.minTickets_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  maxTickets_control = new FormControl('', [Validators.required]);

  getErrorMessage_maxTickets() {
    if (this.maxTickets_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  maxPerUser_control = new FormControl('', [Validators.required]);

  getErrorMessage_maxPerUser() {
    if (this.maxPerUser_control.hasError('required')) {
      return this.langJson.events.formRequiredField;
    }
    return '';
  }

  // Métodos para gestionar el formulario dinámico
  addFormField() {
    const newField: any = {
      name: '',
      type: 'text',
      webName: '',
      required: false
    };
    if (newField.type === 'select') {
      newField.options = [];
    }
    this.formData.push(newField);
    this.editingFieldIndex = this.formData.length - 1;
  }

  editFormField(index: number) {
    this.editingFieldIndex = index;
  }

  saveFormField(index: number) {
    const field = this.formData[index];

    if (!field.name || !field.webName) {
      this.showBottomAlert('El nombre y el nombre web son obligatorios', 'error');
      return;
    }

    // Validar que el nombre no tenga espacios ni caracteres especiales
    if (!/^[a-zA-Z0-9_]+$/.test(field.name)) {
      this.showBottomAlert('El nombre solo puede contener letras, números y guiones bajos', 'error');
      return;
    }

    // Validar que no haya nombres duplicados
    const duplicateIndex = this.formData.findIndex((f, i) => i !== index && f.name === field.name);
    if (duplicateIndex !== -1) {
      this.showBottomAlert('Ya existe un campo con ese nombre', 'error');
      return;
    }

    // Si es select, validar que tenga al menos una opción
    if (field.type === 'select') {
      if (!field.options || field.options.length === 0) {
        this.showBottomAlert('Los campos de tipo select deben tener al menos una opción', 'error');
        return;
      }
      // Validar que todas las opciones tengan nombre
      const invalidOption = field.options.find((opt: any) => !opt.name || opt.name.trim() === '');
      if (invalidOption) {
        this.showBottomAlert('Todas las opciones deben tener un nombre', 'error');
        return;
      }
    } else {
      // Si no es select, eliminar las opciones si existen
      delete field.options;
    }

    this.editingFieldIndex = -1;
  }

  cancelEditFormField() {
    // Si es un campo nuevo sin datos, eliminarlo
    const index = this.editingFieldIndex;
    if (index >= 0 && (!this.formData[index].name || !this.formData[index].webName)) {
      this.formData.splice(index, 1);
    }
    this.editingFieldIndex = -1;
  }

  deleteFormField(index: number) {
    this.formData.splice(index, 1);
    if (this.editingFieldIndex === index) {
      this.editingFieldIndex = -1;
    } else if (this.editingFieldIndex > index) {
      this.editingFieldIndex--;
    }
  }

  isEditingField(index: number): boolean {
    return this.editingFieldIndex === index;
  }

  // Métodos para gestionar opciones de campos select
  onFieldTypeChange(index: number) {
    const field = this.formData[index];
    if (field.type === 'select') {
      // Inicializar opciones si no existen
      if (!field.options) {
        field.options = [];
      }
    } else {
      // Eliminar opciones si no es select
      delete field.options;
    }
  }

  addOption(fieldIndex: number) {
    const field = this.formData[fieldIndex];
    if (!field.options) {
      field.options = [];
    }
    field.options.push({ name: '' });
  }

  removeOption(fieldIndex: number, optionIndex: number) {
    const field = this.formData[fieldIndex];
    if (field.options && field.options.length > optionIndex) {
      field.options.splice(optionIndex, 1);
    }
  }

  hasOptions(fieldIndex: number): boolean {
    const field = this.formData[fieldIndex];
    return field.type === 'select' && field.options && field.options.length > 0;
  }
}
